import { defineStore } from 'pinia'
import { HistoryItem } from '@/models/History'
import { RainRuiHistoryItem } from '@/models/RainRuiHistory'
import repositoryFactory from '@/factories/repository-factory'
import HistoryRepository from '@/repositories/history-repository'
import RainRuiHistoryRepository from '@/repositories/rain-rui-history-repository'
import { rangeToISO } from '@/lib/formatter'
import { WEATHER_FIELDS } from '@/lib/constants'

type State = {
  data: {
    [stationId: string]: HistoryItem[]
  }
  dataRui: RainRuiHistoryItem[]
  dataWeather: HistoryItem[]
}

export const useReportData = defineStore('reportData', {
  state: () =>
    ({
      data: {},
      dataRui: [],
      dataWeather: [],
    } as State),

  actions: {
    async fetch(stationIds: string[], type: string, range: Range, target: string[]) {
      const results: { [stationId: string]: HistoryItem[] } = {}
      const promises: Promise<void>[] = []
      const repository = (await repositoryFactory.create()).get('history') as HistoryRepository

      stationIds.forEach(async stationId => {
        const params = {
          stationId,
          range: {
            ...rangeToISO(range),
            type,
          },
          target,
        }

        const promise = repository.get(params).then(response => {
          results[stationId] = response.items
        })

        promises.push(promise)
      })

      await Promise.all(promises)

      this.data = results

      return Promise.resolve()
    },

    async fetchWeather(stationId: string, type: string, range: Range) {
      const target = WEATHER_FIELDS.map(f => f.snakeCaseValue)
      const repository = (await repositoryFactory.create()).get('history') as HistoryRepository

      const params = {
        stationId,
        range: {
          ...rangeToISO(range),
          type,
        },
        target,
      }

      const response = await repository.get(params)

      this.dataWeather = response.items

      return Promise.resolve()
    },

    async fetchRui(stationId: string, range: Range) {
      const repository = (await repositoryFactory.create()).get('rainRuiHistory') as RainRuiHistoryRepository
      const params = { stationId, range: rangeToISO(range) }
      const response = await repository.get(params)

      this.dataRui = response.data

      return Promise.resolve()
    },
  },
})
